import React from "react";
import image1 from "../Assets/Images/image1.jpeg";
import image2 from "../Assets/Images/image2.jpeg";
import image3 from "../Assets/Images/image3.jpeg";

function HelpPlataform() {
  return (
    <div className="help">
      <h1 className="help__title">Nuestra Plataforma</h1>
      <p className="help__intro">¡Hacemos todo fácil y rápido para ti!</p>

      <h2 className="help__subtitle">💡 ¿Cómo funciona?</h2>

      <div className="help__section">
        <div className="help__content">
          <h3><span className="rocket">🚀</span> 1. Realiza tu recarga</h3>
          <ul>
            <li>Haz una transferencia a la cuenta que te proporcionamos.</li>
            <li>🚨 Importante: La transferencia debe ser desde una cuenta a tu nombre (debe coincidir con los datos de tu usuario verificado).</li>
            <li>📎 Adjuntar el comprobante de la transferencia.</li>
          </ul>
          <img src={image1} alt="Realiza tu recarga" className="help__image" />
        </div>

        <div className="help__content">
          <h3><span className="rocket">🚀</span> 2. Detección automática</h3>
          <ul>
            <li>Nuestro sistema detecta automáticamente tu pago.</li>
            <li>Una vez acreditado, el saldo en euros, dólares o libras esterlinas se reflejará en tu billetera.</li>
            <li>🔍 Puedes revisar el estado de tu recarga en la sección de "Historial de Recargas".</li>
            <li>📊 Nuestro sistema te notificará por correo electrónico cada vez que se realice una actualización en tu saldo.</li>
          </ul>
          <img src={image2} alt="Detección automática" className="help__image" />
        </div>

        <div className="help__content">
          <h3><span className="rocket">🚀</span> 3. Envía remesas</h3>
          <ul>
            <li>Con el saldo disponible, agrega a tus beneficiarios.</li>
            <li>Elige el método de envío:</li>
            <ul>
              <li>💳 Transferencia bancaria</li>
              <li>📱 Pago móvil</li>
            </ul>
            <li>✅ Confirmación inmediata y recibo digital disponible en tu cuenta.</li>
          </ul>
          <img src={image3} alt="Envía remesas" className="help__image" />
        </div>
      </div>

      <h2 className="help__subtitle">✅ Beneficios clave</h2>
      <ul className="help__benefits">
        <li>⚡ Rápido y seguro: Todo el proceso es automatizado y verificado.</li>
        <li>💳 Fácil de usar: Solo necesitas seguir unos simples pasos.</li>
        <li>📩 Notificaciones: Todo será notificado mediante correo electrónico.</li>
        <li>🌍 Envíos flexibles: Elige la opción que mejor se adapte a tus necesidades.</li>
      </ul>

      <p className="help__conclusion">¡Así de sencillo es usar nuestra plataforma! 🚀</p>
      <p className="help__cta">¿Listo para empezar? ¡Haz tu primera recarga y envía remesas hoy mismo!</p>
    </div>
  );
}

export { HelpPlataform };